export default function (http) {
    return {
        queryCardGrantPage (data){
            return http.json({
                url: '/card/apply/query',
                data
            });
        },
        exportExcel(data){
            return http.json({
                url: '/card/apply/export',
                data
            });

        },

        removeCardGrant (data){
            return http.json({
                url: '/card/apply/delete',
                data
            });
        },

        saveOperateGrantInfo (data){
            return http.json({
                url: '/card/apply/save',
                data
            });
        },

        queryOperateGrantInfo (data){
            return http.json({
                url: '/card/apply/getOne',
                data
            });
        },
        querycardInfos (data){
            return http.json({
                url: '/card/info/query',
                data
            });
        },
        getMaxBatch(data){
            return http.json({
                url: '/card/apply/getMaxBatch',
                data
            });
        },

        queryBindDevicePage (data){
            return http.json({
                url: '/sys/org/device/query',
                data
            });
        },

        removeDeviceBind (data){
            return http.json({
                url: 'sys/org/device/delete',
                data
            });
        },

        queryDeviceBindInfo (data){
            return http.json({
                url: '/sys/org/device/getOne',
                data
            });
        },

        saveDeviceBindInfo (data){
            return http.json({
                url: '/sys/org/device/save',
                data
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/operate.js